import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'

import AIPPE from './Forms/AIPPE'
import AIDangerZone from './Forms/AIDangerZone'

const AIConfigModal = ({ camera_id, closemodal }) => {
  const [currentTab, setCurrentTab] = useState()

  return (<>
    <Tabs value={currentTab} onChange={(_, value) => setCurrentTab(value)}>
      <Tab label="PPE" value="ppe"/>
      <Tab label="Danger Zone" value="danger_zone"/>
    </Tabs>

    <Box style={{ flexGrow: 1, overflow: "auto" }}>
      {currentTab === "ppe" && 
        <AIPPE camera_id={camera_id} toggle={closemodal}/>
      }

      {currentTab === "danger_zone" && 
        <AIDangerZone camera_id={camera_id} toggle={closemodal}/>
      }
    </Box>
  </>)
}

export default AIConfigModal
